module.exports = __webpack_public_path__ + "static/media/7.6065d1d9.png";